import { useTranslation } from 'react-i18next';
import { tss } from 'tss-react';

const Help = () => {
	const { t } = useTranslation();
	const { classes, cx } = useStyles();

	return (
		<div className={cx(classes.container, 'container')}>
			<h1>{t('_general:HELP')}</h1>
			<hr />
			<iframe
				src="https://airflow.air-4you.xyz/chat/share?shared_id=fe4da0f28d5011f0bf30ce25661dc4db&from=agent&auth=JlMDRjNmQ4OGQ1NDExZjA4NzcyZmU1NG"
				style={{
					width: '100%',
					height: '100%',
					minHeight: '600px',
					border: '1px solid #ccc',
				}}
			></iframe>
		</div>
	);
};

export default Help;

export const useStyles = tss.create({
	container: {
		height: '100%',
		padding: '20px 20px',
		display: 'flex',
		flexDirection: 'column',
	},
});
